import { Action } from 'redux';
import {
  AnalyticsCountryUsersItem,
  AnalyticsDimensionActivityItem,
  AnalyticsPeriod,
  AnalyticsReportUsageItem,
  AnalyticsSummary,
  AnalyticsUserActivityItem,
} from '../../services/AnalyticsApi';
import { HttpErrorBaseAction, RemoteResource } from '../../types';

export interface State {
  period: AnalyticsPeriod;
  summary: RemoteResource<AnalyticsSummary>;
  reportsUsage: RemoteResource<AnalyticsReportUsageItem[]>;
  reportsTop: RemoteResource<AnalyticsReportUsageItem[]>;
  usersActivity: RemoteResource<AnalyticsUserActivityItem[]>;
  countriesActivity: RemoteResource<AnalyticsDimensionActivityItem[]>;
  rolesActivity: RemoteResource<AnalyticsDimensionActivityItem[]>;
  countriesUsers: RemoteResource<AnalyticsCountryUsersItem[]>;
  countryReportsActivity: RemoteResource<AnalyticsDimensionActivityItem[]>;
  roleReportsActivity: RemoteResource<AnalyticsDimensionActivityItem[]>;
  countryRolesActivity: RemoteResource<AnalyticsDimensionActivityItem[]>;
}

export enum ActionType {
  findAnalyticsRequested = 'analytics/findAnalyticsRequested',
  findAnalyticsSummarySuccess = 'analytics/findAnalyticsSummarySuccess',
  findAnalyticsUsageSuccess = 'analytics/findAnalyticsUsageSuccess',
  findAnalyticsTopSuccess = 'analytics/findAnalyticsTopSuccess',
  findAnalyticsUsersSuccess = 'analytics/findAnalyticsUsersSuccess',
  findAnalyticsCountriesSuccess = 'analytics/findAnalyticsCountriesSuccess',
  findAnalyticsRolesSuccess = 'analytics/findAnalyticsRolesSuccess',
  findAnalyticsCountriesUsersSuccess = 'analytics/findAnalyticsCountriesUsersSuccess',
  findAnalyticsCountryReportsSuccess = 'analytics/findAnalyticsCountryReportsSuccess',
  findAnalyticsRoleReportsSuccess = 'analytics/findAnalyticsRoleReportsSuccess',
  findAnalyticsCountryRolesSuccess = 'analytics/findAnalyticsCountryRolesSuccess',
  findAnalyticsFailure = 'analytics/findAnalyticsFailure',
}

export type FindAnalyticsRequestedAction = Action<ActionType.findAnalyticsRequested> & {
  period?: AnalyticsPeriod;
};

export type FindAnalyticsSummarySuccessAction = Action<ActionType.findAnalyticsSummarySuccess> & {
  summary: AnalyticsSummary;
};

export type FindAnalyticsUsageSuccessAction = Action<ActionType.findAnalyticsUsageSuccess> & {
  reportsUsage: AnalyticsReportUsageItem[];
};

export type FindAnalyticsTopSuccessAction = Action<ActionType.findAnalyticsTopSuccess> & {
  reportsTop: AnalyticsReportUsageItem[];
};

export type FindAnalyticsUsersSuccessAction = Action<ActionType.findAnalyticsUsersSuccess> & {
  usersActivity: AnalyticsUserActivityItem[];
};

export type FindAnalyticsCountriesSuccessAction =
  Action<ActionType.findAnalyticsCountriesSuccess> & {
    countriesActivity: AnalyticsDimensionActivityItem[];
  };

export type FindAnalyticsRolesSuccessAction = Action<ActionType.findAnalyticsRolesSuccess> & {
  rolesActivity: AnalyticsDimensionActivityItem[];
};

export type FindAnalyticsCountriesUsersSuccessAction =
  Action<ActionType.findAnalyticsCountriesUsersSuccess> & {
    countriesUsers: AnalyticsCountryUsersItem[];
  };

export type FindAnalyticsCountryReportsSuccessAction =
  Action<ActionType.findAnalyticsCountryReportsSuccess> & {
    countryReportsActivity: AnalyticsDimensionActivityItem[];
  };

export type FindAnalyticsRoleReportsSuccessAction =
  Action<ActionType.findAnalyticsRoleReportsSuccess> & {
    roleReportsActivity: AnalyticsDimensionActivityItem[];
  };

export type FindAnalyticsCountryRolesSuccessAction =
  Action<ActionType.findAnalyticsCountryRolesSuccess> & {
    countryRolesActivity: AnalyticsDimensionActivityItem[];
  };

export type FindAnalyticsFailureAction = HttpErrorBaseAction<ActionType.findAnalyticsFailure>;

export type Actions =
  | FindAnalyticsRequestedAction
  | FindAnalyticsSummarySuccessAction
  | FindAnalyticsUsageSuccessAction
  | FindAnalyticsTopSuccessAction
  | FindAnalyticsUsersSuccessAction
  | FindAnalyticsCountriesSuccessAction
  | FindAnalyticsRolesSuccessAction
  | FindAnalyticsCountriesUsersSuccessAction
  | FindAnalyticsCountryReportsSuccessAction
  | FindAnalyticsRoleReportsSuccessAction
  | FindAnalyticsCountryRolesSuccessAction
  | FindAnalyticsFailureAction;
